import { render, staticRenderFns } from "./StatusTabSkeletons.vue?vue&type=template&id=ef264dca&scoped=true&"
import script from "./StatusTabSkeletons.vue?vue&type=script&lang=ts&"
export * from "./StatusTabSkeletons.vue?vue&type=script&lang=ts&"
import style0 from "./StatusTabSkeletons.vue?vue&type=style&index=0&id=ef264dca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef264dca",
  null
  
)

export default component.exports